<template>
  <div class="controls-container">

    <div  class="progress"
           ref="progress"
          @click="goTo">
      <div class="bar" :style="{ transform: `scaleX(${barWidth})` }"/>
    </div>

    <div class="controls">
      <audio  class="audio"
              ref="audio"
              :src="currentSrc">
      </audio>

      <div class="top-infos">
        <div class="time">{{fomattedCurrentTime}}</div>
        <div class="name" @click="focus">
          {{currentName}}
          <span class="category" v-if="currentCategory">{{currentCategory}}</span>
          </div>
        <div class="time">{{fomattedDuration}}</div>
      </div>

      <div class="buttons">
        <div class="relative side-buttons">
          <button @click="toggleMuted" class="control toggleable" :data-active="isMuted">
            <svg v-show="!isMuted" aria-hidden="true" viewBox="0 0 480 512"><path fill="currentColor" d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.53 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" class=""></path></svg>
            <svg v-show="isMuted" aria-hidden="true" viewBox="0 0 512 512"><path fill="currentColor" d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z" class=""></path></svg>
          </button>
          <input type="range" min="0" max="100" class="volume-slider" :value="volumeOrMuted" @input="setVolume"/>
        </div>

        <button @click="previous" class="control">
          <svg aria-hidden="true" viewBox="0 0 512 512"><path fill="white" d="M267.5 281.2l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L267.5 232c-15.3 12.8-15.3 36.4 0 49.2zM464 130.3V382L313 256.6l151-126.3zM11.5 281.2l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L11.5 232c-15.3 12.8-15.3 36.4 0 49.2zM208 130.3V382L57 256.6l151-126.3z" class=""></path></svg>
        </button>

        <button @click="playpause" class="control">
          <svg v-show="isPlaying" aria-hidden="true" viewBox="0 0 448 512"><path fill="white" d="M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6zM448 79v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6h-84c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6z" class=""></path></svg>
          <svg v-show="!isPlaying" aria-hidden="true" viewBox="0 0 448 512"><path fill="white" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z" class=""></path></svg>
        </button>

        <button @click="next" class="control">
          <svg aria-hidden="true" viewBox="0 0 512 512"><path fill="white" d="M244.5 230.8L52.5 71.4C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.6c15.3-12.8 15.3-36.4 0-49.2zM48 381.7V130.1l151 125.4L48 381.7zm452.5-150.9l-192-159.4C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.6c15.3-12.8 15.3-36.4 0-49.2zM304 381.7V130.1l151 125.4-151 126.2z" class=""></path></svg>
        </button>

        <div class="side-buttons">
          <button @click="toggleRepeat" class="control toggleable" :data-active="isRepeat">
            <svg aria-hidden="true" viewBox="0 0 512 512"><path fill="white" d="M481.162 164.326c19.478 25.678 30.997 57.709 30.836 92.388C511.61 340.638 442.361 408 358.436 408H176v64c-.001 10.683-12.949 16.021-20.485 8.485l-88-87.995c-4.686-4.686-4.687-12.284 0-16.971l88-88.005c7.58-7.58 20.485-2.14 20.485 8.485v64h182.668C415.933 360 464.06 313.154 464 255.889c-.023-22.372-7.149-43.111-19.237-60.082-3.431-4.817-2.962-11.387 1.223-15.564 8.269-8.255 13.592-13.545 17.137-17.104 5.131-5.152 13.645-4.605 18.039 1.187zM48 256.111C47.94 198.846 96.067 152 153.332 152H336v64c0 10.625 12.905 16.066 20.485 8.485l88-88.005c4.687-4.686 4.686-12.285 0-16.971l-88-87.995C348.949 23.979 336.001 29.317 336 40v64H153.564C69.639 104 .389 171.362.002 255.286c-.16 34.679 11.358 66.71 30.836 92.388 4.394 5.792 12.908 6.339 18.039 1.188 3.545-3.559 8.867-8.849 17.137-17.105 4.185-4.178 4.653-10.748 1.223-15.564-12.088-16.971-19.213-37.71-19.237-60.082zm179.263 43.416c0-7.477 3.917-11.572 11.573-11.572h15.131v-39.878c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.939c4.449-4.095 8.366-5.697 14.42-5.697h12.105c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572h-67.293c-7.656 0-11.573-4.095-11.573-11.572v-8.9z" class=""></path></svg>
          </button>
          <button @click="toggleRandom" class="control toggleable" :data-active="isRandom">
            <svg aria-hidden="true" viewBox="0 0 512 512"><path fill="white" d="M505 400l-79.2 72.9c-15.1 15.1-41.8 4.4-41.8-17v-40h-31c-3.3 0-6.5-1.4-8.8-3.9l-89.8-97.2 38.1-41.3 79.8 86.3H384v-48c0-21.4 26.7-32.1 41.8-17l79.2 71c9.3 9.6 9.3 24.8 0 34.2zM12 152h91.8l79.8 86.3 38.1-41.3-89.8-97.2c-2.3-2.5-5.5-3.9-8.8-3.9H12c-6.6 0-12 5.4-12 12v32c0 6.7 5.4 12.1 12 12.1zm493-41.9l-79.2-71C410.7 24 384 34.7 384 56v40h-31c-3.3 0-6.5 1.4-8.8 3.9L103.8 360H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h111c3.3 0 6.5-1.4 8.8-3.9L372.2 152H384v48c0 21.4 26.7 32.1 41.8 17l79.2-73c9.3-9.4 9.3-24.6 0-33.9z" class=""></path></svg>
          </button>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import scrollTo from '@/services/scrollTo.js'
export default {
  name: 'audio-controls',
  props: ['episode'],
  data () {
    return {
      isPlaying: false,
      duration: 0,
      currentTime: 0,
      isRandom: false,
      isRepeat: false,
      isMuted: false,
      volume: 100
    }
  },
  computed: {
    volumeOrMuted () {
      return this.isMuted ? 0 : this.volume
    },
    audio () {
      return this.$refs.audio
    },
    currentSrc () {
      return this.episode ? this.episode.path : null
    },
    currentName () {
      return this.episode ? this.episode.name : 'Choisis un épisode, là !'
    },
    currentCategory () {
      return this.episode ? this.episode.category : null
    },
    fomattedDuration () {
      return this.formatDuration(this.duration)
    },
    fomattedCurrentTime () {
      return this.formatDuration(this.currentTime)
    },
    barWidth () {
      if (this.duration && this.currentTime) {
        return this.currentTime / this.duration
      } else {
        return 0
      }
    }
  },
  methods: {
    setVolume (event) {
      this.isMuted = false
      this.audio.muted = this.isMuted
      this.volume = event.target.value
      this.audio.volume = event.target.value / 100
    },
    toggleMuted () {
      this.isMuted = !this.isMuted
      this.audio.muted = this.isMuted
    },
    focus () {
      if (this.episode) {
        scrollTo(this.episode.id)
      }
    },
    toggleRandom () {
      this.isRandom = !this.isRandom
      if (this.isRandom) {
        this.isRepeat = false
      }
    },
    toggleRepeat () {
      this.isRepeat = !this.isRepeat
      if (this.isRepeat) {
        this.isRandom = false
      }
    },
    playpause () {
      if (this.isPlaying) {
        this.pause()
      } else {
        this.play()
      }
    },
    async play () {
      if (this.episode) {
        await this.audio.play()
      } else {
        this.next()
      }
    },
    pause () {
      this.audio.pause()
    },
    goTo (event) {
      const progressRect = this.$refs.progress.getBoundingClientRect()
      const total = progressRect.width
      const origin = progressRect.left
      const clickPosition = event.clientX
      const progress = clickPosition - origin
      const ratio = progress / total
      this.audio.currentTime = ratio * this.duration
    },
    formatDuration (duration) {
      const minutes = Math.floor(duration / 60)
      var seconds = Math.floor(duration % 60)
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      return `${minutes}:${seconds}`
    },
    next () {
      this.$emit('next', this.isRandom)
    },
    previous () {
      this.$emit('previous', this.isRandom)
    }
  },
  mounted () {
    this.audio.addEventListener('play', (event) => {
      this.isPlaying = true
    })
    this.audio.addEventListener('pause', (event) => {
      this.isPlaying = false
    })
    this.audio.addEventListener('durationchange', (event) => {
      this.duration = event.target.duration
    })
    this.audio.addEventListener('canplay', (event) => {
      this.play()
    })
    this.audio.addEventListener('timeupdate', (event) => {
      this.currentTime = event.target.currentTime
    })
    this.audio.addEventListener('ended', (event) => {
      if (this.isRepeat) {
        this.play()
      } else {
        this.next()
      }
    })
    document.addEventListener('keydown', (event) => {
      const enabled = this.$store.getters.enabledKeyboardControls
      if (!enabled) {
        return
      }
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault()
        this.playpause()
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault()
        this.next()
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault()
        this.previous()
      }
    })
  }
}
</script>

<style scoped lang="scss">

.controls-container {
  width: 100%;
}
.controls {
  padding: 0 15px 15px 15px;
  background-color: $darkerviolet;
  color: $whitish;
}

.progress {
  height: 15px;
  width: 100%;
  background-color: $whitish;
  cursor: pointer;
  border-top: 2px solid $darkerviolet;
}
.bar {
  height: 100%;
  width: 100%;
  background-color: $red;
  transform-origin: left;
}

.name {
  text-align: center;
  padding: 0 15px;
  min-height: 35px;
  max-height: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  cursor: pointer;

  .category {
    font-size: .8em;
    color: $white-tr;
    margin-top: 5px;
  }
}
.time {
  width: 35px;
  min-width: 35px;
  text-align: center;
}
.top-infos {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
}

.buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.control {
  background-color: unset;
  border: none;
  outline: none;
  height: 50px;
  width: 50px;
  padding: 0 7px;
  cursor: pointer;
  svg {
    height: 100%;
    width: 100%;
  }
  transition: transform 100ms ease-in-out;
  &:active  {
    transform: scale(.8);
  }
}
.toggleable {
  height: 35px;
  width: 35px;
  path {
    fill: gray;
  }
  &[data-active] path {
    fill: $blue;
  }
}

.volume-slider {
  max-width: 60px;
  width: 100%;
}

.side-buttons {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>
